/*
 * CompUK storefront motion — scroll-reveal orchestration only.
 * The `.cuk-reveal` hidden/animated state lives in tailwind.css and is gated on
 * BOTH `prefers-reduced-motion: no-preference` AND the `cuk-js` class on <html>
 * (added inline in the head), so content is never hidden without JS or for users
 * who prefer reduced motion. This file just toggles `.is-in` when elements enter
 * the viewport, with a light stagger, and is defensive about dynamic content.
 */
(function () {
  var d = document;
  var root = d.documentElement;
  root.classList.add('cuk-js');
  // Tell the inline head fallback that motion is handling reveals.
  window.__cukMotionReady = true;

  function revealAll() {
    var els = d.querySelectorAll('.cuk-reveal');
    for (var i = 0; i < els.length; i++) els[i].classList.add('is-in');
  }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var inEditor = window.Shopify && window.Shopify.designMode;

  // No animation path: show everything up front (also keeps the theme editor sane).
  if (reduce || inEditor || !('IntersectionObserver' in window)) {
    if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', revealAll);
    else revealAll();
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      var e = entries[i];
      if (e.isIntersecting) {
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      }
    }
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  function applyStagger(el) {
    var grid = el.closest('ul, [data-cuk-grid], .grid');
    if (!grid) return;
    var reveals = grid.querySelectorAll('.cuk-reveal');
    var idx = Array.prototype.indexOf.call(reveals, el);
    var delay = Math.min((idx < 0 ? 0 : idx) * 70, 420);
    if (delay > 0) el.style.setProperty('--cuk-reveal-delay', delay + 'ms');
  }

  function scan() {
    var els = d.querySelectorAll('.cuk-reveal:not(.is-in)');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.__cukSeen) continue;
      el.__cukSeen = true;
      applyStagger(el);
      io.observe(el);
    }
  }

  function start() {
    scan();

    // Reveal nodes added later (load-more, category filter, etc.).
    if ('MutationObserver' in window) {
      var queued = false;
      var mo = new MutationObserver(function () {
        if (queued) return;
        queued = true;
        (window.requestAnimationFrame || window.setTimeout)(function () {
          queued = false;
          scan();
        });
      });
      mo.observe(d.body, { childList: true, subtree: true });
    }

    // Safety net: never leave in-view content hidden if the observer misfires.
    window.setTimeout(function () {
      var els = d.querySelectorAll('.cuk-reveal:not(.is-in)');
      for (var i = 0; i < els.length; i++) {
        var r = els[i].getBoundingClientRect();
        if (r.top < (window.innerHeight || 0) + 200) els[i].classList.add('is-in');
      }
    }, 3500);
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start);
  else start();
})();
